import { useMemo } from 'react';
import { EmployeePermissions, ResourceUIType } from '@/service/Api/types';

export default function useGetLayoutPermissions(
  resources: ResourceUIType[],
  currentUserPermissions?: EmployeePermissions[]
) {
  const layoutPermissions = useMemo(() => {
    const permissions = currentUserPermissions?.filter((access) =>
      resources.some((resource) => resource === access.resource)
    );
    const newPermissions = new Map<ResourceUIType, Array<'read' | 'delete' | 'update' | 'create'>>();
    permissions?.forEach((permission) => {
      newPermissions.set(permission.resource, permission.can);
    });
    return newPermissions;
  }, [currentUserPermissions, resources]);

  return { layoutPermissions };
}
